'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = {
    mapService: 'WMS',
    imageFormat: 'PNG',
    mapLayerPosition: 'BASEMAP'
};
module.exports = exports['default'];
//# sourceMappingURL=externalMapLayer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/externalMapLayer.js
// module id = 91
// module chunks = 0